import { userService } from '@/_services'
import { api } from '@/_api'

export const charge = {
  namespaced: true,
  state: {
    values: {},
    current: null
  },
  mutations: {
    set(state, channel_id) {
      if (!userService.check()) {
        state.current = false
        return
      } else if (!channel_id) {
        state.current = false
        return
      } else if (state.values[channel_id] == null) {
        state.values[channel_id] = false
        api.pay.check(channel_id)
          .then(data => {
            state.values[channel_id] = Boolean(data)
            state.current = state.values[channel_id]
          })
      } else state.current = state.values[channel_id]
    },
    setPay(state, { channel_id, value }) {
      state.values[channel_id] = Boolean(value)
      state.current = value
    }
  },
  actions: {
    async set({ commit }, channel_id) {
      commit('set', channel_id)
    }
  },
  getters: {
    isPay: state => state.current
  }
}